document.addEventListener("DOMContentLoaded",function()
{


    function init()
    {

       
        inicializar_carrusel_bannershome();  
        inicializarCarruselTestimoniales();
        //inicializarCarruselPropuestasDeValor();
    
    
    }


    function inicializar_carrusel_bannershome()
    {


      

      
        jQuery('.carrusel-bannershome').slick(
            
                                                    {
                                                        slidesToShow:1,
                                                        autoplaySpeed:3000,
                                                        autoplay: true,
                                                        slidesToScroll:1,
                                                        dots: true,
                                                        arrows:false,
                                                        draggable:true
                                                    }
            
                                                ); 

     
                                  

    }
    
    function inicializar_carrusel_anunciosheader()
    {

        setTimeout(()=>
            {

                const carruselEnvios = document.querySelector(".contenedor-carrusel-envios .carrusel-bannersenvio");

             
                if(carruselEnvios)
                    {

                        
                                    jQuery('.contenedor-carrusel-envios .carrusel-bannersenvio').slick(
            
                                                                                       {
                                                                                                slidesToShow:1,
                                                                                                autoplaySpeed:3000,
                                                                                                autoplay: true,
                                                                                                slidesToScroll:1,
                                                                                                dots: true,
                                                                                                arrows:false,
                                                                                                draggable:true
                                                                                            }

                                                                                         );
                                                


                    }else
                    {


                        inicializar_carrusel_anunciosheader();


                    }


                

            },5000);

      
                                                
             


    }



    


    function inicializar_carrusel_marcasfavoritas()
    {


      
        jQuery('.carrusel-marcasfavoritas').slick(
            
                                                    {
                                                        slidesToShow:5,
                                                        autoplaySpeed:3000,
                                                        autoplay: true,
                                                        slidesToScroll:1,
                                                        dots: false,
                                                        arrows:true,
                                                        responsive:[
            
                                                                
                                                                    {
                                                                        breakpoint: 992,
                                                                        settings: {
                                                                        slidesToShow: 4
                                                                        }
                                                                    },
                                                                    {
                                                                        breakpoint: 660,
                                                                        settings: {
                                                                        slidesToShow: 3
                                                                        }
                                                                    },

                                                                    {
                                                                        breakpoint: 460,
                                                                        settings: {
                                                                        slidesToShow: 2
                                                                        }
                                                                    }

                                                        ]
                                                    }
            
                                                ); 

     


    }


    function inicializarCarruselTestimoniales()
    {


        jQuery('.carrusel-testimoniales').slick({
        slidesToShow:4,
        autoplay: false,
        slidesToScroll:1,
        dots: true,
      
        responsive:[

        
        {
            breakpoint: 960,
            settings: {
            slidesToShow: 3
            }
        },
        {
            breakpoint: 720,
            settings: {
            slidesToShow: 1
            }
        }
        ]
    });




    }

    function inicializarCarruselPropuestasDeValor()
    {


        jQuery('.carrusel-diferenciales').slick({
        slidesToShow:4,
        autoplay: false,
        slidesToScroll:1,
        dots: true,
        arrows:false,
      
        responsive:[

        
        {
            breakpoint: 960,
            settings: {
            slidesToShow: 3
            }
        },
        {
            breakpoint: 720,
            settings: {
            slidesToShow: 2
            }
        }
        ]
    });




    }


        
 


  init();

  
  
});